import styled, { keyframes, css } from "styled-components";
import { IAnimationProps, IDragSimulatorProps } from "./interfaces";

export const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${p => p.theme.c.blackShadow35};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
`;

export const Modal = styled.div`
    background-color: ${p => p.theme.c.snow};
    box-shadow: 0 3px 9px ${p => p.theme.c.blackShadow5};
    padding: 20px;
    border-radius: 8px;

    p {
        margin-bottom: -30px;
        font-size: 20px;
        margin-top: 0;
    }

    .button {
        margin-bottom: 0;
        margin-top: -45px;
    }

    ${p =>
        p.theme.xs(css`
            transform: scale(1.8);
        `)}
    ${p =>
        p.theme.sm.only(css`
            transform: scale(1.5);
        `)}
    ${p =>
        p.theme.md.only(css`
            transform: scale(1.2);
        `)}
`;

export const DemoContainer = styled.div`
    width: 256px;
    height: 224px;
    position: relative;
    margin: auto;
`;

const dragAnimationRight = keyframes`
    0% {
        transform: translate(128px, 128px);
    }
    17% {
        transform: translate(128px, 128px);
    }
    34% {
        transform: translate(128px, 128px);
    }
    51% {
        transform: translate(160px, 128px);
    }
    68% {
        transform: translate(160px, 128px);
    }
    85% {
        transform: translate(128px, 128px);
    }
    100% {
        transform: translate(128px, 128px);
    }
`;

const dragAnimationLeft = keyframes`
    0% {
        transform: translate(128px, 128px);
    }
    17% {
        transform: translate(128px, 128px);
    }
    34% {
        transform: translate(128px, 128px);
    }
    51% {
        transform: translate(96px, 128px);
    }
    68% {
        transform: translate(96px, 128px);
    }
    85% {
        transform: translate(128px, 128px);
    }
    100% {
        transform: translate(128px, 128px);
    }
`;

const dragButtonAnimation = (p: IAnimationProps) => keyframes`
    0% {
        background-color: ${p.theme.c.white};
        color: ${p.theme.c.black};
        transform: scale(1);
    }
    17% {
        background-color: ${p.theme.c.active};
        color: ${p.theme.c.white};
        transform: scale(1.1);
    }
    68% {
        background-color: ${p.theme.c.active};
        color: ${p.theme.c.white};
        transform: scale(1.1);
    }
    85% {
        background-color: ${p.theme.c.white};
        color: ${p.theme.c.black};
        transform: scale(1);
    }
    100% {
        background-color: ${p.theme.c.white};
        color: ${p.theme.c.black};
        transform: scale(1);
    }
`;

const alternateAnimation = keyframes`
    0% {
        width: 0;
        opacity: 0;
    }
    43% {
        width: 0;
        opacity: 0;
    }
    44% {
        width: auto;
        opacity: 1;
    }
    68% {
        width: auto;
        opacity: 1;
    }
    69% {
        width: 0;
        opacity: 0;
    }
    100% {
        width: 0;
        opacity: 0;
    }
`;

const normalAnimation = keyframes`
    0% {
        width: auto;
        opacity: 1;
    }
    43% {
        width: auto;
        opacity: 1;
    }
    44% {
        width: 0;
        opacity: 0;
    }
    68% {
        width: 0;
        opacity: 0;
    }
    69% {
        width: auto;
        opacity: 1;
    }
    100% {
        width: auto;
        opacity: 1;
    }
`;

export const DragSimulator = styled.div<IDragSimulatorProps>`
    position: absolute;
    left: 0;
    top: 0;
    animation: ${p => (p.isLeft ? dragAnimationLeft : dragAnimationRight)} 3s infinite;

    .Button {
        animation: ${p => dragButtonAnimation(p)} 3s infinite;
    }

    .Altered {
        animation: ${alternateAnimation} 3s infinite;
    }
    .Normal {
        animation: ${normalAnimation} 3s infinite;
    }
`;
